/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name daygridline
 */
angular.module('mercury.modules.time.roster')
.directive('daygridline', ["$timeout", function($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element) {
      var check = function() {
        element.height(angular.element('#editor-body').height() - 38);
        $timeout(check, 50);
      };

      $timeout(check, 50);
    }
  };
}]);
